import styled from 'styled-components';
import { CardInput } from '../../components/CardInputs/CardsStyledComponents';
import { TextMedium, TextRegular } from '../../styles/GlobalStyledComponents';
import {
  ButtonsWrapper,
  ButtonType,
} from '../../components/Button/ButtonStyledComponent';

interface EntrySectionProps {
  $marginBottom: boolean;
}

export const EntryContainer = styled.div<EntrySectionProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 15px 0; */

  @media (max-width: 850px) {
    margin-bottom: ${(props) => (props.$marginBottom ? '160px' : '0px')};
  }
`;

export const EntryText = styled(TextRegular)`
  color: ${(props) => props.theme.colors.gray6};
  @media screen and (min-width: 320px) and (max-width: 479px) {
    margin: 20px 15px 15px 15px;
  }
`;

export const PromotionSection = styled(CardInput)`
  flex-direction: column;
  @media (max-width: 650px) {
    padding: 15px 10px;
  }
`;

interface PromotionSectionTitleProps {
  hidden: boolean;
}

export const PromotionSectionTitle = styled.div<PromotionSectionTitleProps>`
  display: ${(props) => (props.hidden ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
`;

export const CollapseArrow = styled.img`
  width: 22px;
  padding: 5px;
  margin-right: 5px;
`;

export const PromotionImage = styled.img`
  width: auto;
  border-top-right-radius: 0%;
`;

export const PromotionText = styled.p``;

export const PromotionsAmount = styled.div`
  border-radius: 50px;
  background-color: ${(props) => props.theme.colors.red7};
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0 5px 2px;
  font-size: 13px;
  font-weight: 600;
`;

export const Promotion = styled.span`
  font-weight: bolder;
`;

export const PromotionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-bottom: 10px;
  width: 100%;
  @media (max-width: 650px) {
    padding: 0px 15px 8px 15px;
  }
`;

export const PromotionsList = styled.div``;

export const CardValues = styled.div``;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: 700px;
  padding: 10px;
  margin: 0 auto;
  /* box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
  border-radius: 16px 16px 0px 0px; */
  position: relative;
  bottom: 0;
  left: 0;

  @media (max-width: 850px) {
    position: fixed;
    max-width: 100%;
    flex-direction: column;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    border-radius: 16px 16px 0px 0px;
    background-color: #ffff;
    z-index: 98;
  }
`;

export const ButtonsWrapperEntry = styled(ButtonsWrapper)`
  @media (max-width: 850px) {
    padding: 0px;
    max-width: 100%;
  }
`;

export const OneClickButton = styled(ButtonType)`
  @media (max-width: 931px) {
    font-size: 16px;
    gap: 2px;
  }
  @media (max-width: 900px) {
    font-size: 14px;
  }
  @media (max-width: 850px) {
    font-size: 18px;
    gap: 4px;
  }
`;

export const ImgCard = styled.div`
  margin: 0px 5px;
  padding: 0px;

  @media (max-width: 930px) {
    margin: 0px 2px;
  }

  svg {
    @media (min-width: 851px) and (max-width: 930px) {
      width: 70%;
    }
  }
`;

export const FourDigitsText = styled(TextMedium)`
  @media (min-width: 851px) and (max-width: 900px) {
    font-size: 12px;
  }
`;
